/* eslint-disable no-console */
import { onError as apolloLinkOnError } from 'apollo-link-error';
import { isAuthenticationError } from 'services/apollo-client/index';
import { isFunction } from 'lodash';

interface ErrorHandlerParams {
  graphQLErrors: any[];
  networkError: any;
  operation: any;
  forward: any;
  response: any;
}

const errorMiddleware = new Map();

function errorHandler(params: ErrorHandlerParams) {
  const { graphQLErrors, networkError } = params;

  const notAuthenticated = graphQLErrors?.some(isAuthenticationError);

  if (notAuthenticated) {
    // Refresh the session and redo request
    /*const oldHeaders = operation.getContext().headers;
    const token = await refreshSession();

    operation.setContext({
      headers: {
        ...oldHeaders,
        authorization: `Bearer ${token}`
      }
    });
    // retry the request, returning the new observable
    return forward(operation);*/
  }

  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path, extensions }) => {
      if (process.env.NODE_ENV !== 'production') {
        console.log(
          `%c [GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
          'color: red;',
        );

        const stackTrace = extensions?.exception?.stacktrace?.reduce(
          (message, line) => {
            return `${message}\n${line}`;
          },
          '',
        );
        console.log(`%c ${stackTrace}`, 'color: red;');
      }
    });
  }

  if (networkError && process.env.NODE_ENV !== 'production') {
    try {
      console.log(
        `%c [Network error]: ${JSON.stringify(networkError)}`,
        'color: red;',
      );
    } catch {
      console.log(`%c [Network error]: ${networkError}`, 'color: red;');
    }
  }

  setTimeout(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
    () => [...errorMiddleware].map(([_, callback]) => callback(params)),
    500,
  );
}

export function onError(
  name: string,
  callback: (params: ErrorHandlerParams) => void,
) {
  if (isFunction(callback) === false) {
    throw new Error('Error link: onError second argument must be a function.');
  }

  errorMiddleware.set(name, callback);
}

// @ts-ignore
export default apolloLinkOnError(errorHandler);
